.container {
  position: relative;
  width: 3em;
  min-height: 2em;
  margin: auto;
}

.button {
  border: 0;
  background-color: inherit;
  line-height: 1;
  margin: 0;
  padding: 0;
  color: var(--blue);

  &:hover {
    color: var(--blueActive);
  }

  &:disabled {
    color: var(--mediumSilver);
  }
}

.list {
  position: absolute;
  top: 100%;
  right: -0.2em;
  min-width: 20em;
  padding: 1.5em 1em;
  border: 1px solid var(--blue);
  border-radius: 5px;
  box-shadow: 0 0 2px;
  background-color: var(--white);
  z-index: 4;
  text-align: right;

  &::before {
    content: "";
    position: absolute;
    top: -20px;
    right: 12px;
    border: 10px solid transparent;
    border-bottom-color: var(--blue);
  }

  &::after {
    content: "";
    position: absolute;
    top: -16px;
    right: 14px;
    border: 8px solid transparent;
    border-bottom-color: var(--white);
  }
}

.header {
  font-size: 0.9em;
  color: var(--gray);
  text-transform: uppercase;
  line-height: 2;
}

.itemText {
  font-size: 0.8em;
  font-weight: 700;
  line-height: 2;
}

.menuItem {
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: flex-end;
  width: 100%;
}

.liIcon {
  margin-right: 0.3em;
}

@media (max-width: 48em) {
  .container {
    width: 1em;
    margin-left: 0.5em;
    margin-right: auto;
  }

  .list {
    right: -0.5em;

    &::before {
      right: 0;
    }

    &::after {
      right: 2px;
    }
  }
}
